import { HeaderText as SharedHeaderText } from '../../components/atomic/text/header_text/HeaderText';
import headerTextImg from '../content/header_text.png';
import './HeaderText.css';

/** From Figma — «ЛИЦЕНЗИЯ КУРЬЕРА», top 145.5 / left 233. */
export function HeaderText() {
  return (
    <SharedHeaderText
      className="player-level-header-text"
      src={headerTextImg}
      alt="Лицензия курьера"
    />
  );
}
